import { createRouter, createWebHistory } from 'vue-router';
import MainPage from '../views/MainPage.vue';
import LoginPage from "../views/LoginPage.vue";
import { useAuthStore } from "../store/authstore";
import { generateRouting } from "./pages";
import DoMaintenance from "@/views/DoMaintenance.vue";
import IssuesPage from "../views/IssuesPage.vue";

const routes = [
  { path: '/', component: MainPage },
  { path: '/login', component: LoginPage, meta: { isPublic: true }, },
  { path: '/domaintenance/:parkId/', component: DoMaintenance, meta: { hideNavBar: true, show: false } },
  { path: '/showdomaintenance/:domId/', component: DoMaintenance, meta: { hideNavBar: true, show: true } },
  { path: '/issuepanel/:issueId/', component: IssuesPage },
  ...generateRouting()
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const isPublic = to.meta['isPublic'] ?? false;
  const auth = useAuthStore();

  if (!isPublic && !await auth.isLogged(to)) {
    auth.$patch({ returnUrl: to.fullPath });
    return '/login';
  }
});

router.afterEach((to) => {
  document.title = 'RE Superadmin';
});

export default router;
